import { Button, message, Radio } from 'antd';
import React, { useState } from 'react';
import Auxiliary from '../../util/Auxiliary';
import QRReader from 'react-qr-reader';
import CameraScanner from './CameraScanner';
import InputScanner from './InputScanner';

const CAMERA = 'camera';
const INPUT = 'input';

const Index = ({ onScan }) => {
  const [scanType, setScanType] = useState(CAMERA);

  const Content = () => {
    if (scanType === CAMERA) {
      return <CameraScanner onScan={onScan} />;
    }

    if (scanType === INPUT) {
      return <InputScanner onScan={onScan} />;
    }
  }

  return (
    <Auxiliary>
      <Radio.Group defaultValue={scanType} buttonStyle="solid" onChange={(e) => setScanType(e.target.value)}>
        <Radio.Button value={CAMERA}>Scan QR Code</Radio.Button>
        <Radio.Button value={INPUT}>Input ID</Radio.Button>
      </Radio.Group>

      <Content />

    </Auxiliary>
  );
}

export default Index;